import { OrganizationMember } from '@prisma/client'
import { useNavigate, useParams } from '@remix-run/react'
import { Button, Card, Flex, Typography } from 'antd'
import { useOrganizationContext } from '~/core/context'
import { Api } from '~/core/trpc'
import { RenderMarkdownContent } from '~/features/chatV3/client/components/Thread/components/RenderMarkdownContent'
import { NotFound } from '../NotFound'

type Props = {
  fileId: string
  organizationMember: OrganizationMember
}

export const Thumbnail: React.FC<Props> = ({ fileId }) => {
  const params = useParams<{ conversationId: string }>()
  const conversationId = params.conversationId
  const navigate = useNavigate()
  const fileQuery = Api.driveFile.findUnique.useQuery(
    {
      where: {
        id: fileId,
      },
    },
    { initialData: null },
  )

  const { organization } = useOrganizationContext()

  const fileUrl = `/organizations/${organization?.data?.id}/chat/${conversationId}/files/${fileId}`

  const goToFile = () => {
    navigate(fileUrl)
  }

  if (!fileQuery.data) {
    return <NotFound />
  }

  if (['plain/text', 'text/plain'].includes(fileQuery.data.mimetype)) {
    return (
      <Card
        onClick={goToFile}
        hoverable
        style={{
          height: '350px',
          maxWidth: '300px',
          overflowY: 'hidden',
          overflowX: 'hidden',
          padding: 0,
          maskImage: 'linear-gradient(to bottom, black 90%, transparent 100%)',
        }}
      >
        <Flex
          vertical
          gap={8}
          align="flex-start"
          justify="flex-start"
          style={{
            transform: 'scale(0.5)',
            transformOrigin: 'top left',

            width: '200%', // Compensate for the scaling (1/0.85 ≈ 1.18)
          }}
        >
          <RenderMarkdownContent content={fileQuery.data.content} />
        </Flex>
        <Button
          size="small"
          style={{
            position: 'absolute',
            bottom: '12px',
            right: '12px',
            zIndex: 10,
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          }}
          onClick={e => {
            e.stopPropagation() // Prevent card click event
            goToFile()
          }}
        >
          Read More
        </Button>
      </Card>
    )
  }

  return (
    <Card onClick={goToFile} hoverable style={{ maxWidth: '600px' }}>
      <Flex vertical gap={8} align="flex-start" justify="center">
        <Typography.Text type="secondary">
          {fileQuery.data.name}
        </Typography.Text>
      </Flex>
      <Button
        size="small"
        style={{
          position: 'absolute',
          bottom: '12px',
          right: '12px',
          zIndex: 10,
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        }}
        onClick={e => {
          e.stopPropagation() // Prevent card click event
          goToFile()
        }}
      >
        View
      </Button>
    </Card>
  )
}
